module.exports = __webpack_public_path__ + "static/img/stage-mode-4.eb8ee2b8.png";